import { AppReadyStateContainer } from '@/containers/AppReadyState';
import { AppStateEffectContainer } from '@/containers/AppStateEffect';
import { AppThemingContainer } from '@/containers/AppTheming';
import { BrandInsightsContainer } from '@/containers/BrandInsights';
import { QueryDownloaderContainer } from '@/containers/QueryDownloader/QueryDownloader.Container';
import { FileUploadsState, FileUploadsProgressContainer } from '@/containers/WorkspaceFileUpload/';
import { MuiThemeProvider } from './MuiThemeProvider';

export const AppSubscriber = (props: ChildrenProps) => {

  return (
    <QueryDownloaderContainer>
      <AppReadyStateContainer>
        <AppStateEffectContainer>
          <AppThemingContainer>
            <MuiThemeProvider>
              <FileUploadsState>
                <BrandInsightsContainer>
                  <FileUploadsProgressContainer>
                    {props.children}
                  </FileUploadsProgressContainer>
                </BrandInsightsContainer>
              </FileUploadsState>
            </MuiThemeProvider>
          </AppThemingContainer>
        </AppStateEffectContainer>
      </AppReadyStateContainer>
    </QueryDownloaderContainer>
  );
};